// extracted by mini-css-extract-plugin
export default {"action":"action-BrO9","button":"button-BT4k"};